// @flow
import React, { Component } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import EstimateBoxTable from 'components/estimate/EstimateBoxTable/EstimateBoxTable';
import { type UserData } from 'store/modules/user';
import { EstimateActions, UserActions } from 'store/actionCreators';
import { getEstimate, type UploadInfo } from 'store/modules/estimate';
import axios from 'axios';
import storage, { keys } from 'lib/storage';

type Props = {
  user: ?UserData,
  estimate: ?getEstimate,
  uploadInfo: ?UploadInfo,
};

class EstimateBoxTableContainer extends Component<Props> {
  initialize = () => {
    const { user, id } = this.props;
    if (!user) return;
    EstimateActions.getEstimateBox(user.username);
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.user && this.props.user) {
      this.initialize();
    }
  }

  uploadFile = async (file: any, estimateId: any) => {
    if (file.size > 1024 * 1024 * 10) return;
    // const fileTypeRegex = /^image\/(.*?)/;
    // if (!fileTypeRegex.test(file.type)) return;
    // if (file.type.indexOf('gif') > 0) return;
    try {
      // const filename = escapeForUrl(file.name);
      await EstimateActions.createEstimateBoxSignedUrl(file.name, estimateId);
      if (!this.props.uploadInfo) return;
      const { url, file_path: filePath } = this.props.uploadInfo;
      await axios.put(url, file, {
        headers: {
          'Content-Type': file.type,
        },
        withCredentials: false,
        onUploadProgress: e => {
          if (window.nanobar) {
            window.nanobar.go((e.loaded / e.total) * 100);
          }
        },
      });
      // 리스트 불러 오기
      this.initialize();
      await UserActions.checkUser();
      storage.set(keys.user, this.props.user);
    } catch (e) {
      console.log(e);
    }
  };

  onUploadEstimate = async estimateId => {
    const upload = document.createElement('input');
    upload.type = 'file';
    upload.onchange = e => {
      if (!upload.files) return;
      const file = upload.files[0];
      this.uploadFile(file, estimateId);
    };
    upload.click();
  };

  onRemoveEstimate = async (id, idx) => {
    const { user } = this.props;
    if (!user) return;
    try {
      await EstimateActions.removeEstimateBox(user.username, id, idx);
    } catch (e) {
      console.log(e);
    }
  };

  onViewEstimate = () => {
    console.log('onViewEstimate');
  };

  render() {
    const { estimate } = this.props;
    if (!estimate) return null;
    return (
      <EstimateBoxTable
        estimate={estimate}
        onUploadEstimate={this.onUploadEstimate}
        onRemoveEstimate={this.onRemoveEstimate}
        onViewEstimate={this.onViewEstimate}
      />
    );
  }
}

export default connect(
  ({ user, estimate }: State) => ({
    user: user.user,
    estimate: estimate.estimateBox,
    uploadInfo: estimate.uploadInfo,
  }),
  () => ({}),
)(EstimateBoxTableContainer);



// WEBPACK FOOTER //
// ./src/containers/estimate/EstimateBoxTableContainer.js